module.exports = __webpack_public_path__ + "img/wrappingup.cd571939.png";